import * as config from "../config.js";

export const getMediaItem = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! MEDIA ITEM ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/media/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const results = await response.json();
  if (results.success) {
    return results.media;
  }

  return null;
};

export const updateMediaItem = async (mediaItem) => {
  const url = `${config.REST_SERVER_URL}/admin/media/${mediaItem.public_id}`;
  const response = await fetch(url, {
    method: "PUT",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
    body: JSON.stringify(mediaItem),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const media = await response.json();
  return media;
};

export const deleteMediaItem = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/media/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const media = await response.json();
  return media;
};

export const getMediaChunkText = async (mediaChunkId) => {
  const url = `${config.REST_SERVER_URL}/admin/media/getchunktext/${mediaChunkId}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    }, credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}


